import * as AppVersionType from "fleet/constant/app-version-type";
import { AppDetailsPage } from "fleet/view/application/details";
import React from "react";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import {
  applicationsSelector,
  EDIT_APPLICATION,
} from "redux-store/applications";
import { getAuthUser } from "redux-store/auth";
import * as Users from "redux-store/users/selectors";
import { storesReady } from "redux-store/utils";

function mapStateToProps(state, props) {
  const { id } = props.match.params || {};
  const storesLoaded = storesReady(state.global.applications);
  const appById = applicationsSelector(state);
  const app = appById[id];
  const user = getAuthUser(state);
  const isAdmin = Users.isAdmin(user);

  return {
    app,
    isAdmin,
    storesLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    editApp: (serviceArgs) => {
      const { id, operation, status, versionId } = serviceArgs;

      return createPromiseApiAction(dispatch, EDIT_APPLICATION, [
        id,
        operation,
        status,
        versionId,
      ]);
    },
  };
}

const ConnectedAppDetailsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppDetailsPage);

function StableAppDetailsPage(props) {
  return <ConnectedAppDetailsPage {...props} type={AppVersionType.STABLE} />;
}

function TestingAppDetailsPage(props) {
  return <ConnectedAppDetailsPage {...props} type={AppVersionType.TESTING} />;
}

export { ConnectedAppDetailsPage, StableAppDetailsPage, TestingAppDetailsPage };
